module.exports = __webpack_public_path__ + "static/31invgde-bae682d9cd44129c1dfb965b6011c68f.gif";